function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ConsentTypeChoice INSTEAD.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioField } from '@unite-us/ui';
import classNames from 'classnames';
import { get } from 'lodash';

/**
 * @visibleName ConsentTypeChoice DEPRECATED
*/

var SHORT_LABEL_MAX_LENGTH = 40;
var columnClass = function columnClass(label, isLabelColumn) {
  var longLabel = get(label, 'length', 0) > SHORT_LABEL_MAX_LENGTH;
  if (!longLabel) {
    return classNames({
      'radio-column': isLabelColumn,
      'col-sm-4': isLabelColumn,
      'col-sm-8': !isLabelColumn
    });
  }
  return classNames({
    'radio-column': isLabelColumn,
    'col-sm-6': true
  });
};
var ConsentTypeChoice = /*#__PURE__*/function (_Component) {
  function ConsentTypeChoice(props) {
    var _this;
    _classCallCheck(this, ConsentTypeChoice);
    _this = _callSuper(this, ConsentTypeChoice, [props]);
    _this.onSelect = _this.onSelect.bind(_this);
    return _this;
  }
  _inherits(ConsentTypeChoice, _Component);
  return _createClass(ConsentTypeChoice, [{
    key: "onSelect",
    value: function onSelect() {
      this.props.onSelect(this.props.type);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        dropzone = _this$props.dropzone,
        label = _this$props.label,
        selectedType = _this$props.selectedType,
        type = _this$props.type;
      var isSelected = type === selectedType;
      return /*#__PURE__*/React.createElement("div", {
        className: "consent-type-choice"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: columnClass(label, true)
      }, /*#__PURE__*/React.createElement(RadioField, {
        id: type,
        name: type,
        value: isSelected ? type : '',
        onChange: this.onSelect,
        options: [{
          label: label,
          value: type
        }]
      })), /*#__PURE__*/React.createElement("div", {
        className: columnClass(label, false)
      }, isSelected ? /*#__PURE__*/React.createElement("div", {
        className: "consent-type-choice__children"
      }, children) : null)), isSelected && dropzone ? /*#__PURE__*/React.createElement("div", {
        className: "row consent-type-choice__dropzone"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12"
      }, dropzone)) : null);
    }
  }]);
}(Component);
ConsentTypeChoice.propTypes = {
  /** Children content shown on the right side of the radio field */
  children: PropTypes.node.isRequired,
  /** Represents the dropzone file transfer if addeded */
  dropzone: PropTypes.any,
  /** Label of the RadioField */
  label: PropTypes.node.isRequired,
  /** Function when radio is selected */
  onSelect: PropTypes.func.isRequired,
  /** Value of what is currently selected via parent component */
  selectedType: PropTypes.string.isRequired,
  /** Value of ConsentTypeChoice component */
  type: PropTypes.string.isRequired
};
ConsentTypeChoice.defaultProps = {
  dropzone: null
};
export default ConsentTypeChoice;